import { useAddressSearch } from '@gov-nx/core/hooks';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useProfilROSReklamaceContextInstance } from '@gov-nx/module/page';
import {
	Button,
	FormInput,
	FormSelect,
	FormWidthElementLayout,
	LayoutGap,
} from '@gov-nx/ui/web';

export interface AddressFormProps {
	code: PageCode;
	isProcessing: boolean;
}

export const AddressSearchForm = ({ code, isProcessing }: AddressFormProps) => {
	const { address, mainQuery, formDefinition, setControls, controls } =
		useProfilROSReklamaceContextInstance();
	const { disableSearchButton } = useAddressSearch({
		formMethods: formDefinition.formMethods,
	});
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const ts = getLocalizeCurried(code);

	return (
		<FormWidthElementLayout type="l">
			<LayoutGap gap="m">
				<FormInput
					field={{
						name: 'nazevObce',
						isDisabled: isProcessing,
						placeholder: ts('formular.placeholders.nazev-obce'),
					}}
					label={{ children: ts('formular.pole.nazev-obce') }}
				/>
				<FormInput
					field={{
						name: 'nazevUlice',
						isDisabled: isProcessing,
						placeholder: ts('formular.placeholders.nazev-ulice'),
					}}
					label={{ children: ts('formular.pole.nazev-ulice') }}
				/>
				<FormInput
					field={{
						name: 'cislo',
						isDisabled: isProcessing,
						placeholder: ts('formular.placeholders.cislo-evidencni-popisne'),
					}}
					label={{ children: ts('formular.pole.cislo-evidencni-popisne') }}
				/>
				<Button
					onClick={() => {
						mainQuery.refetch();
						setControls({ displaySearchAddressLoading: true });
					}}
					isDisabled={disableSearchButton || isProcessing}
					isLoading={controls.displaySearchAddressLoading}
					nativeType="button"
					color="primary"
					size="m"
					type="outlined">
					{ts('akce.vyhledat')}
				</Button>
				{mainQuery.isFetched && (
					<FormSelect
						field={{
							name: 'newAddress',
							isDisabled: isProcessing,
							children: (
								<>
									<option
										value=""
										disabled>
										{ts('formular.pole.neuvedeno')}
									</option>
									{address.map((address) => (
										<option
											value={address.kod}
											key={address.kod}>
											{address.adresaText}
										</option>
									))}
								</>
							),
						}}
						label={{
							children: ts('formular.pole.nova-adresa'),
						}}
					/>
				)}
			</LayoutGap>
		</FormWidthElementLayout>
	);
};
